import React, { Component } from 'react';
// utils
import debounce from 'lodash.debounce';
import moment from 'moment';
// redux
import { connect } from 'react-redux';
import { getMyJournals } from '../../../redux/reducers/journals';
// components
import Input from '../../../components/Input/Input';
import Datepicker from '../../../components/Datepicker/Datepicker';
// styles
import styles from './FilterMyJournals.mod.css';
import classnames from 'classnames/bind';

let cn = classnames.bind(styles);

class FilterMyJournals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      date_from: moment(props.userRegisteredAt),
      date_to: moment()
    };
    this.debouncedFilterMyJournals = debounce(this.handleFilterMyJournals, 300);
  }

  handleFilterMyJournals = () => {
    const { getMyJournals, per_page } = this.props;
    const { title, date_to, date_from } = this.state;
    getMyJournals({
      page: 1,
      per_page,
      filter: {
        title,
        date_to: moment(date_to).format('YYYY-MM-DD'),
        date_from: moment(date_from).format('YYYY-MM-DD')
      }
    });
  };

  onTitleChange = ({ target: { value } }) => {
    this.setState({ title: value }, this.debouncedFilterMyJournals);
  };

  onDateFromChange = value => {
    this.setState({ date_from: value }, this.debouncedFilterMyJournals);
  };

  onDateToChange = value => {
    this.setState({ date_to: value }, this.debouncedFilterMyJournals);
  };

  render() {
    const { title, date_from, date_to } = this.state;
    const { className, userColor } = this.props;
    return (
      <div className={cn(className, 'wrapper')}>
        <Input
          color={userColor}
          wrapperClassName={cn('filter', 'input-wrapper')}
          placeholder="Search"
          name="title"
          value={title}
          onChange={this.onTitleChange}
        />
        <div className={cn('datepickers-section')}>
          <div className={cn('filter', 'data-picker')}>
            <Datepicker
              color={userColor}
              name="date_from"
              selected={date_from}
              onChange={this.onDateFromChange}
            />
          </div>
          <div className={cn('filter', 'data-picker')}>
            <Datepicker
              color={userColor}
              name="date_to"
              selected={date_to}
              onChange={this.onDateToChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ journals, auth }) => ({
    per_page: journals.params.per_page,
    userRegisteredAt: auth.user.created_at
  }),
  { getMyJournals }
)(FilterMyJournals);



// WEBPACK FOOTER //
// ./src/containers/Journal/components/FilterMyJournals.jsx